// daily_audio_status values used in UserContext
export const AUDIO_STATUS = {
  GENERATING: "generating",
  READY: "ready",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
};

// Generation progress statuses from the backend
export const GENERATION_PROGRESS = {
  DONE: "done",
  ERROR: "error",
  SYNTHESIZING_AUDIO: "synthesizing_audio",
  COMBINING_AUDIO: "combining_audio",
};
